import { DateTime } from "common/time/DateTime";
import moment from "moment";
import React, { useEffect, useState } from "react";
import styles from "./Time.scss";

export const Time = () => {
  const [t, setT] = useState(moment());
  const updateT = () => setT(moment());
  useEffect(() => {
    const interval = setInterval(updateT, 1000);
    return () => clearInterval(interval);
  }, []);

  const anHourAgo = moment().subtract(1, "hour");
  const yesterday = moment().subtract(1, "day");
  const month = moment().subtract(1.1, "months");
  const year = moment().subtract(1.1, "years");

  return (
    <div className={styles.Time}>
      <h1>Time</h1>
      <p>
        By default, <code>DateTime</code> respect <code>currentUser.date_format</code>.
      </p>
      <div className={styles.times}>
        <span>
          <DateTime t={t} short />
        </span>
        <span>
          <DateTime t={t} medium />
        </span>
        <span>
          <DateTime t={t} long />
        </span>
        <span>
          <DateTime t={t} long includeSeconds />
        </span>
      </div>
      <p>
        It also supports <code>relative</code> time.
      </p>
      <div className={styles.times}>
        <span>
          <DateTime t={anHourAgo} relative />
        </span>
        <span>
          <DateTime t={yesterday} relative />
        </span>
        <span>
          <DateTime t={month} relative />
        </span>
        <span>
          <DateTime t={year} relative />
        </span>
      </div>
    </div>
  );
};
